import { DOOR_TYPE_DATA } from '../actions/actionType'

const initialState = {
  doorTypes: [],
}
export default function DoorTypeReducer(state = initialState, action) {
  switch (action.type) {
    case DOOR_TYPE_DATA:
      return { ...state, doorTypes: action.payload }
    default:
      return state
  }
}
